import React from 'react';

export const MainLogo = ({ className = 'w-[255px] h-[197px]', variant = 'dark' }) => {
  return (
    <img
      src={`/${variant === 'dark' ? 'gcm-main-logo.svg' : 'gcm-main-logo-light.svg'}`}
      alt="Gift Card Market"
      className={className}
      style={{
        objectFit: 'cover',
      }}
    />
  );
};
